import spinner from "../assets/icons/spinner.gif";
import React from "react";

const Spinner = () => {
    return (
        <>
            <img width="120px" src={spinner} alt=""/>
        </>
    )
} 

export default Spinner